import React from 'react'
import {sortBy} from 'lodash'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'

import LocationModal from './modal/LocationModal'
import DeleteModal from '../../components/DeleteModal'

import * as locationService from '../../services/location-service'

export default class Locations extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.buttonFormatter = this.buttonFormatter.bind(this)
    this.deleteId = this.deleteId.bind(this)

    this.state = { 
      location: undefined
    }
  }

  deleteId(id) {
    locationService.deleteLocation(id).then(() => this.props.refresh())
  }

  buttonFormatter(cell, row, id) {
    return (
      <div className='row-actions'>
        <LocationModal 
          title="Wijzigen locatie"
          modalbttext=" Wijzigen"
          id={row.id}
          reload={() => this.props.refresh()} />

        <DeleteModal
          title="Verwijderen locatie"
          text="Wilt u deze locatie verwijderen? Let op: alle lopende of voltooide scans en alle onderliggende organisatorische eenheden worden dan ook uit BrandWijzer verwijderd."
          className='delete-entry action-btn'
          delete={() => this.deleteId(row.id)}>
        </DeleteModal>
      </div>
    )
  }

  render() {
    function headerFormatter(column, colIndex, { sortElement }) {
      return (
        <span className="sortable-inner">
          <span className="text">{column.text}</span>
          {sortElement}
        </span>
      )
    }

    function contentFormatter(cell, row) {
      return (
        <span className="text">{cell}</span>
      )
    }

    const { locations } = this.props

    const columns = [{
      dataField: 'name',
      text: 'Locatie',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'button',
      text: ' ',
      formatter: this.buttonFormatter
    }]

    const paginationOptions = paginationFactory({
      sizePerPageList: [{
        value: 20
      }],
      paginationSize: 5,
      hideSizePerPage: true,
      alwaysShowAllBtns: true
    })

    return (
      <div className="tab-inner table-page locations">
        <BootstrapTable
          keyField='id'
          data={sortBy(locations, "name")}
          columns={columns}
          bordered={ false }
          striped
          hover
          condensed
          pagination={ paginationOptions } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Locations/index.js